<div
    class="bg-card flex h-16 flex-0 flex-col border-b px-6 dark:bg-zinc-800 sm:flex-row sm:items-center sm:justify-between sm:px-5"
>
    <div class="flex h-full min-w-0 flex-1 flex-row items-center gap-8">
        <!-- Title -->
        <div class="flex">
            <!-- Logo -->
            <div class="mr-4 w-16">
                <img src="images/logo/logo.svg" />
            </div>
        </div>

        <!-- Toggle -->
        <div class="w-16">
            <button mat-icon-button (click)="matDrawerToggle()">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
        </div>
    </div>

    <!-- Actions -->
    <div class="ml-auto flex h-16 shrink-0 items-center gap-3 sm:ml-4 sm:mt-0">
        <app-notifications></app-notifications>
        <app-user-menu
            class="translate-y-0.5"
            [showAvatar]="true"
        ></app-user-menu>
    </div>
</div>
